import React, { useState, useEffect } from "react";
import { Button, Table, Spinner, Modal } from "react-bootstrap";
import { del } from "../../../../helpers/api_helper";
import action_icon_1 from "../../../../Assets/svg/tableData/action-icon-1.svg";
import action_icon_2 from "../../../../Assets/svg/tableData/action-icon-2.svg";
import AddNewStockExchange from "./Modal/AddNewStockExchange";
import moment from "moment-timezone";
import toast from "react-hot-toast";
import DeleteConfirmationModal from "../../../../components/DeleteConfirmation";
import { useSelector } from "react-redux";
import useCheckPermission from "../../../../hooks/useCheckPermission";

const TableData = ({ stockData, setRefresh }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [selectedStock, setSelectedStock] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [stockToDelete, setStockToDelete] = useState(null);

  const hasUpdatePermission = useCheckPermission("marketStock", "UPDATE");
  const hasDeletePermission = useCheckPermission("marketStock", "DELETE");

  useEffect(() => {
    if (stockData && stockData.length > 0) {
      setLoading(false);
    }
  }, [stockData]);

  const handleDelete = async () => {
    try {
      const response = await del(`/admin/stock-exchange/${stockToDelete}`);
      if (response.success) {
        toast.success("Stock exchange deleted successfully");
        setRefresh((prev) => !prev);
      } else {
        toast.error("Failed to delete stock data");
      }
    } catch (err) {
      toast.error("An error occurred while deleting stock data");
    } finally {
      setShowConfirm(false);
    }
  };

  const handleEdit = (stock) => {
    setSelectedStock(stock);
    setModalMode("edit");
    setShowModal(true);
  };

  const confirmDelete = (id) => {
    setStockToDelete(id);
    setShowConfirm(true);
  };

  function formatTimeWithAMPM(timeString) {
    if (!timeString) {
      return "-";
    }

    const time = new Date(timeString);
    const hours = time.getHours();
    const minutes = time.getMinutes();

    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const period = hours >= 12 ? "PM" : "AM";

    return `${formattedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  }

  return (
    <>
      <AddNewStockExchange
        showModal={showModal}
        setShowModal={setShowModal}
        handleDataRefresh={() => setRefresh((prev) => !prev)}
        mode={modalMode}
        stockData={selectedStock}
      />

      <DeleteConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleDelete}
      />

      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100px" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Table responsive>
          <thead>
            <tr>
              <th className="fw-normal border-0">Ticker Name</th>
              <th className="fw-normal border-0">Stock Exchange</th>
              <th className="fw-normal border-0">Country</th>
              <th className="fw-normal border-0">Timezone</th>
              <th className="fw-normal border-0">Opening Time</th>
              <th className="fw-normal border-0">Closing Time</th>
              <th className="fw-normal border-0">Created At</th>
              <th className="fw-normal border-0">Status</th>
              <th className="fw-normal border-0">Action</th>
            </tr>
          </thead>
          <tbody>
            {stockData && stockData.length > 0 ? (
              stockData?.map((data, key) => (
                <tr key={key}>
                  <td>{data?.ticker_name ? data.ticker_name : "-"}</td>

                  <td>{data?.stock_name ? data.stock_name : "-"}</td>

                  <td>{data?.location ? data.location : "-"}</td>

                  <td>{data?.timezone ? data.timezone?.name : "-"}</td>
                  <td>
                    {data?.opening_time
                      ? formatTimeWithAMPM(data.opening_time)
                      : "-"}
                  </td>
                  <td>
                    {data?.closing_time
                      ? formatTimeWithAMPM(data.closing_time)
                      : "-"}
                  </td>
                  <td>
                    {data?.created_at
                      ? moment(data.created_at).format("DD-MM-YYYY hh:mm A")
                      : "-"}
                  </td>
                  <td>
                    <span className="text-capitalize labelTag greenLabel">
                      {data?.status ? data.status : "-"}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex align-items-center gap-10">
                      {hasUpdatePermission && <Button
                        className="border-0 p-0"
                        variant="transparent"
                        onClick={() => handleEdit(data)}
                      >
                        <img src={action_icon_1} alt="Edit" />
                      </Button>}
                      {hasDeletePermission && <Button
                        className="border-0 p-0"
                        variant="transparent"
                        onClick={() => confirmDelete(data?._id)}
                      >
                        <img src={action_icon_2} alt="Delete" />
                      </Button>}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No data available</td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default TableData;
